import { SectionDivider } from "app/components/shared/SectionDivider";
import GettingStartedImage from "public/cisco-sd-wan/getting-started-banner.webp";
import { Flex, AspectRatio, Text, List, ListItem } from "@chakra-ui/react";
import Image from "next/image";
import Link from "next/link";

const GettingStarted = () => {
  return (
    <>
      <SectionDivider label="Getting started" padding="0 2rem" />
      <Flex
        direction={{ base: "column", md: "row" }}
        gap={10}
        justifyContent={"center"}
        alignItems={"center"}
        data-cy={"section-getting-started"}
      >
        <AspectRatio
          position={"relative"}
          width={{ base: "full", sm: "300px", md: "400px", lg: "450px" }}
        >
          <Image
            alt={"Getting Started"}
            title={"Getting Started"}
            fill
            src={GettingStartedImage}
            sizes="(max-width: 1080px) 100vw, 450px"
            style={{ objectFit: "contain", objectPosition: "center" }}
          />
        </AspectRatio>
        <Flex
          direction={"column"}
          gap={3}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <List styleType={"disc"}>
            <ListItem>
              <Text fontSize={"18px"} color={"gray.800"}>
                Getting Started Guide on{" "}
                <Link
                  href="https://support.cloudmylab.com/"
                  target="_blank"
                  style={{ color: "blue", textDecoration: "underline" }}
                >
                  Knowledge Base.
                </Link>
              </Text>
            </ListItem>
            <ListItem>
              <Text fontSize={"18px"} color={"gray.800"}>
                SD-WAN Troubleshooting Strategies
              </Text>
            </ListItem>
          </List>
        </Flex>
      </Flex>
    </>
  );
};

export default GettingStarted;
